module.exports = __webpack_public_path__ + "static/media/Soft Flour.ca0f7961.png";